export enum AgendaTemplate {
  IntroductionMeeting = 'introductionMeeting',
  RecommendationMeeting = 'recommendationMeeting',
  FollowUpMeeting = 'followUpMeeting',
  ReviewMeeting = 'reviewMeeting',
  ReviewMeetingV2 = 'reviewMeetingV2',
  ReviewMeetingWithReferralRequest = 'reviewMeetingWithReferralRequest',
}
